document.addEventListener("DOMContentLoaded", function () {
  // Wait a moment for any scripts to inject content
  setTimeout(function () {
    // Find all favorite buttons
    const favButtons = document.querySelectorAll(".CAD-wishlist-button button");

    // Add accessibility attributes to each button
    favButtons.forEach((button) => {
      // Get the aria-label from the parent
      const label = button
        .closest(".CAD-wishlist-button")
        .getAttribute("aria-label");

      // Apply it directly to the button
      if (label) {
        button.setAttribute("aria-label", label);

        // Add a visually hidden span with the text for better accessibility
        const span = document.createElement("span");
        span.className = "visually-hidden";
        span.textContent = label;
        button.prepend(span);
      }
    });
  }, 500); // Wait 500ms for any scripts to complete
});
